import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const SocialGoogleplusIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SocialGoogleplus",
    children: /*#__PURE__*/_jsx("path", {
      d: "M19.31 14.7H10.9v3.06h5.04c-.19 1.31-1.48 3.84-5.04 3.84-3.1 0-5.62-2.51-5.62-5.62s2.51-5.62 5.62-5.62h.08c1.34 0 2.57.52 3.47 1.38s2.42-2.34 2.42-2.34a8.62 8.62 0 0 0-5.88-2.31h-.09c-4.92 0-8.9 3.99-8.9 8.9s3.99 8.9 8.9 8.9c5.14 0 8.55-3.62 8.55-8.72v-.09c0-.49-.05-.98-.13-1.45v.05h-.01ZM30 17.27V14.7h-2.53v-2.55h-2.58v2.55h-2.52v2.57h2.52v2.55h2.55v-2.55z"
    })
  }));
};
SocialGoogleplusIcon.displayName = 'SocialGoogleplusIcon';